// Offline incident synchronization is retired. Keep compatibility exports for older callers;
// existing device records remain untouched and are never automatically transmitted.
export const isOnline = () => navigator.onLine;
export const onSyncStatusChange = () => () => {};
export const initSyncManager = () => () => {};
export const syncPendingIncidents = async () => ({ synced: 0, failed: 0 });
export const processSyncQueue = async () => ({ processed: 0, failed: 0 });
export const runFullSync = async () => null;
export const requestBackgroundSync = async () => {};
